import React, { useState } from 'react'
import { Button, Tonality } from '@dsny/dsny-component-library'
import { useTheme } from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useMobileMediaQuery } from 'utils/hooks/useMediaQueries'
import {
  XButtonWrapper,
  ButtonWrapper
} from '../SignoutModal/SignoutModal.styles'
import { Close, Mailemailread } from '@dsny/dsny-component-library/icons'
import { StyledModal } from '../Modals.styles'
import { EmailIconBubble } from '../ConnectEmailModal/ConnectEmailModal.styles'
import { thunks as profileThunks } from 'reducers/Profile'
import { LOADING_STATES } from 'constants/enums'

function UnlinkEmailModal({ isOpen, email, setIsOpen }) {
  const { t } = useTranslation()
  const theme = useTheme()
  const dispatch = useDispatch()
  const isMobile = useMobileMediaQuery()
  const [status, setStatus] = useState(LOADING_STATES.IDLE)

  const handleUnlinkEmail = async () => {
    try {
      await dispatch(profileThunks.startSplitEmail(email))
      setStatus(LOADING_STATES.SUCCESS)
    } catch (error) {
      console.error('Error merging email:', error)
      setStatus(LOADING_STATES.ERROR)
    }
  }

  return (
    <StyledModal
      $isMobile={isMobile}
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      containerStyles={{
        padding: isMobile ? '24px 12px' : '72px 64px 40px'
      }}
    >
      <XButtonWrapper onClick={() => setIsOpen(false)}>
        <Close width={24} height={24} color={theme.colors.neutralW80} />
      </XButtonWrapper>

      <div style={{ display: 'flex', flexDirection: 'row', gap: 16 }}>
        {status === LOADING_STATES.SUCCESS && (
          <EmailIconBubble>
            <Mailemailread width={24} />
          </EmailIconBubble>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
          <Tonality.UIHeading
            headingStyle="headline5"
            color={theme.colors.neutralW90}
            style={{ marginBottom: 8 }}
          >
            {status === LOADING_STATES.SUCCESS
              ? t('settings.unlink-email-sent')
              : t('settings.unlink-email')}
            ?
          </Tonality.UIHeading>

          {status === LOADING_STATES.SUCCESS ? (
            <Tonality.UIText
              textStyle="body"
              color={theme.colors.neutralW70}
              style={{ fontSize: 14, marginBottom: 32 }}
            >
              {t('settings.unlink-email-sent-body')}
            </Tonality.UIText>
          ) : (
            <>
              <Tonality.UIText
                textStyle="body"
                color={theme.colors.neutralW70}
                style={{ fontSize: 14, marginBottom: 24 }}
              >
                {t('settings.unlink-email-body')}
              </Tonality.UIText>
              <Tonality.UIText
                textStyle="body"
                color={theme.colors.neutralW70}
                style={{ fontSize: 14 }}
              >
                {t('settings.unlink-email-body-note')}
              </Tonality.UIText>
            </>
          )}
        </div>
      </div>

      {status !== LOADING_STATES.SUCCESS && (
        <ButtonWrapper style={{ gap: 16, marginTop: isMobile ? 16 : 32 }}>
          <Button
            type="submit"
            variant="primary"
            setting="player"
            mode="dark"
            onClick={handleUnlinkEmail}
          >
            {t('settings.unlink-email')}
          </Button>

          <Button
            variant="secondary"
            setting="player"
            mode="dark"
            type="button"
            onClick={() => setIsOpen(false)}
          >
            {t('settings.keep-it')}
          </Button>
        </ButtonWrapper>
      )}
    </StyledModal>
  )
}

export default UnlinkEmailModal
